import ImportAll from './ImportAll'

const ImportAllPrefs = () => {
  return <ImportAll />
}

export default ImportAllPrefs
